export const appName = "JONDLE";
